import { createContext, useContext } from 'react';
import { Routes } from '../../Routes';
import type { SubmitResponse } from '../api/submit';
import { MixpanelService } from '../services/mixpanel';
import type { ErrorReason } from '../services/mixpanelEvents';
import type { MSISDN } from '../util/msisdn';
import type { ParsedClaims } from './claims';

interface IAppContext {
  apiAuth: string;
  apiSubscriptionId: string;
  currentRoute: Routes;
  savedPhoneNumber?: string;
  submittedPhoneNumber?: MSISDN;
  claims: ParsedClaims | null;
  errorReason?: ErrorReason;
  setSubmitResponse: (res: SubmitResponse) => void;
  setRoute: (route: Routes, errorReason?: ErrorReason) => void;
  updateClaims: (claims: ParsedClaims | null) => void;
  hasAttemptedRedirect: boolean;
  mixpanel: MixpanelService;
}

export const AppContext = createContext<IAppContext | null>(null);

export const useAppContext = (): IAppContext => {
  const values = useContext(AppContext);
  if (values === null) {
    throw new Error('AppContext not initialized');
  }
  return values;
};
